/* i18n语言包（越南语） */

export default {
'sys.operator.success': 'Hoạt động thành công',
'业务异常': 'Kinh doanh bất thường',
'网络请求失败，请稍候再试': 'Yêu cầu mạng không thành công, vui lòng thử lại trong thời gian chờ',
'请输入公司关键词': 'Vui lòng nhập từ khóa công ty',
'公司名不能为空': 'Tên công ty không được để trống',
'请输入用户名': 'Vui lòng nhập tên người dùng',
'用户名不能为空': 'Tên người dùng không được để trống',
'请输入密码': 'Vui lòng nhập mật khẩu',
'密码不能为空': 'Mật khẩu không được để trống',
'长度在 6 到 20 个字符': 'Độ dài từ 6 đến 20 ký tự',
'登录': 'Đăng nhập',
'退出登录': 'Thoát Đăng nhập',
'登录成功': 'Đăng nhập thành công',
'登录失败': 'Đăng nhập thất bại',
'暂无权限，请联系后台管理员': 'Không có quyền, vui lòng liên hệ với quản trị viên',
'向右滑动完成拼图': 'Trượt sang phải để hoàn thành câu đố',
'刷新': 'Làm mới',
'抱歉！': 'Xin lỗi!',
'当前页面不存在...': 'Trang hiện tại không tồn tại...',
'请检查您输入的网址是否正确，或点击下面的按钮返回首页。': 'Vui lòng kiểm tra xem địa chỉ web bạn đã nhập có chính xác không hoặc nhấp vào nút bên dưới để quay lại trang chủ.',
'登录状态已过期，请重新登录!': 'Trạng thái đăng nhập đã hết hạn, vui lòng đăng nhập lại!',
'返回首页': 'Quay lại trang đầu',
'关闭其他': 'Đóng khác', 
'关闭左侧': 'Đóng trái', 
'关闭右侧': 'Đóng bên phải', 
'关闭全部': 'Đóng tất cả',
'搜索': 'Tìm kiếm',
'清空': 'Trống rỗng',
'添加': 'Thêm',
'删除': 'Xoá',
'批量删除': 'Xóa hàng loạt',
'确定': 'Xác định',
'取消': 'hủy bỏ',
'启用': 'Bật',
'禁用': 'Tắt',
'编辑': 'Chỉnh sửa',
'修改': 'Sửa đổi',
'审核': 'Đánh giá',
'反审核': 'Chống kiểm toán',
'条码': 'Mã vạch',
'详情': 'Chi tiết',
'导出Excel': 'Xuất Excel',
'边框': 'Viền',
'大': 'Lớn',
'中': 'Giữa',
'小': 'Nhỏ',
'的订单已签收': 'Đơn đặt hàng đã được ký ',
'，未签收': ', Chưa ký ',
'记住账号密码': 'Ghi nhớ mật khẩu tài khoản',
'MES制造执行系统': 'Hệ thống điều hành sản xuất MES',
'委外订单': 'Đơn đặt hàng ngoài ủy ban',
'请输入订单号': 'Vui lòng nhập số lệnh',
'请选择客户': 'Vui lòng chọn khách hàng',
'请选择订单状态': 'Vui lòng chọn trạng thái đặt hàng',
'单据状态': 'Tình trạng tài liệu',
'订单金额合计': 'Tổng số tiền đặt hàng',
'预计交货时间': 'Thời gian giao hàng dự kiến',
'单据日期': 'Ngày tài liệu',
'已审核': 'Kiểm toán',
'未审核': 'Chưa kiểm toán',
'查询': 'Yêu cầu',
'导出excel成功！': 'Xuất Excel thành công!',
'下达订单': 'Đặt hàng',
'确认要删除该数据吗？': 'Xác nhận rằng bạn muốn xóa dữ liệu đó?',
'提示': 'Mẹo',
'待下单': 'Đặt hàng',
'已下单': 'Đặt hàng',
'已确认': 'Xác nhận',
'已排期': 'Đã lên lịch',
'生产中': 'Trong sản xuất',
'已完工': 'Đã hoàn thành',
'已出货': 'Đã xuất hàng',
'已签收': 'Đã ký',
'已结算': 'Giải quyết',
'已关闭': 'Đóng cửa',
'开始时间': 'Thời gian bắt đầu',
'结束时间': 'Thời gian kết thúc',
'至': 'Đến',
'序号': 'Số sê-ri',
'客户名称': 'Tên khách hàng',
'创建人': 'Tạo bởi',
'暂无数据': 'Không có dữ liệu.',
'操作': 'Hoạt động',
'订单编号': 'Số thứ tự',
'订单类型': 'Loại lệnh',
'订单状态': 'Trạng thái đặt hàng',
'试产': 'Sản xuất thử nghiệm',
'批量': 'Số lượng lớn',
'结算方式': 'Phương thức thanh toán',
'现结': 'Nút hiện tại',
'月结': 'Nút mặt trăng',
'季结': 'Kết thúc mùa',
'年结': 'Kết thúc năm',
'添加委外订单': 'Thêm đơn đặt hàng ngoài ủy ban',
'编辑委外订单': 'Đơn đặt hàng ngoài Ban biên tập',
'请输入订单编号': 'Vui lòng nhập số thứ tự',
'请选择订单类型': 'Vui lòng chọn loại đơn đặt hàng',
'请选择结算方式': 'Vui lòng chọn phương thức thanh toán',
'请选择预计交货时间': 'Vui lòng chọn thời gian giao hàng ước tính',
'请输入': 'Vui lòng nhập',
'请选择': 'Vui lòng chọn',
'上传BOM文件': 'Tải tập tin BOM lên',
'过账标记': 'Đăng ký nhãn',
'过账人': 'Đăng bởi',
'过账时间': 'Thời gian đăng',
'进度': 'Tiến độ',
'生产工单': 'Đơn đặt hàng công việc sản xuất',
'生产计划': 'Kế hoạch sản xuất',
'操作人': 'Người vận hành',
'订单签收': 'Đăng ký đặt hàng',
'签收状态': 'Trạng thái đăng ký',
'送货单号': 'Đơn hàng giao hàng',
'成品名称': 'Tên sản phẩm',
'规格': 'Thông số',
'送货数': 'Số lượng giao hàng',
'签收成功': 'Đăng ký thành công',
'请选择送货单号': 'Vui lòng chọn số giao hàng',
'返回': 'Quay lại',
'委外订单编号': 'Số đơn đặt hàng ngoài ủy ban',
'保存': 'Lưu',
'添加明细': 'Thêm chi tiết',
'物料编号': 'Số vật liệu',
'请选择物料编号': 'Vui lòng chọn số nguyên liệu',
'物料名称': 'Tên vật liệu',
'物料规格': 'Thông số vật liệu',
'单位': 'Đơn vị',
'数量': 'Số lượng',
'请输入数量': 'Vui lòng nhập số lượng',
'单价': 'Đơn giá',
'请输入单价': 'Vui lòng nhập đơn giá',
'含税单价': 'Đơn giá đã bao gồm thuế',
'含税合计': 'Tổng cộng bao gồm thuế',
'税率（%）': 'Thuế suất (%)',
'请输入税率': 'Vui lòng nhập thuế suất',
'税额': 'Số tiền thuế',
'备注': 'Ghi chú',
'销售订单详情': 'Chi tiết đặt hàng',
'请选择物料': 'Vui lòng chọn vật liệu',
'请输入物料编号': 'Vui lòng nhập số nguyên liệu',
'请输入物料名称': 'Vui lòng nhập tên vật liệu',
'提示：双击选择物料！': 'Mẹo: Nhấp đúp để chọn vật liệu!',
'确认要删除选中数据吗？': 'Xác nhận rằng bạn muốn xóa dữ liệu đã chọn?',
'操作成功！': 'Chiến dịch thành công!',
'品名/型号': 'Tên/Mô hình',
'请输入品名/型号': 'Vui lòng nhập tên/model',
'云端工厂': 'Nhà máy đám mây',
'请输入PCB条码': 'Vui lòng nhập mã vạch PCB',
'请输入客户条码': 'Vui lòng nhập mã vạch khách hàng',
'请输入工令单号': 'Vui lòng nhập đơn đặt hàng',
'请选择线别': 'Vui lòng chọn dòng',
'请输入计划序号': 'Vui lòng nhập số kế hoạch',
'请输入机器编号': 'Vui lòng nhập số máy',
'请输入客户订单号': 'Vui lòng nhập số đặt hàng của khách hàng',
'请选择结果': 'Vui lòng chọn kết quả',
'PCB条码': 'Mã vạch PCB',
'板面': 'Mặt tấm',
'客户条码': 'Mã vạch khách hàng',
'工令单号': 'Đơn đặt hàng',
'成品编号': 'Số sản phẩm',
'成品规格': 'Thông số kỹ thuật hoàn thành',
'线别名称': 'Dòng Tên',
'线别编号': 'Số dòng',
'计划序号': 'Số sê-ri kế hoạch',
'客户订单': 'Khách hàng đặt hàng',
'结果': 'Kết quả',
'供应商名称': 'Tên nhà cung cấp',
'供应商编号': 'Số nhà cung cấp',
'机器编号': 'Số máy',
'备注信息': 'Thông tin nhận xét',
'创建时间': 'Thời gian tạo',
'备述': 'Chuẩn bị',
'更新时间': 'Thời gian cập nhật',
'更新人': 'Cập nhật bởi',
'请选择结算状态': 'Vui lòng chọn trạng thái thanh toán',
'未结算': 'Chưa thanh toán',
'订单完结': 'Hoàn tất lệnh',
'成品料号': 'Số sản phẩm đã hoàn thành',
'订单金额': 'Số lượng đặt hàng',
'结算状态': 'Tình trạng thanh toán',
'未付金额': 'Số tiền chưa thanh toán',
'已付金额': 'Số tiền đã thanh toán',
'生产计划序号': 'Kế hoạch sản xuất Số sê-ri',
'完工收货日期': 'Ngày nhận hàng hoàn thành',
'请输入生产日期(D/C)': 'Vui lòng nhập ngày sản xuất (D/C)',
'请输入仓库': 'Vui lòng nhập kho',
'请选择来料类型': 'Vui lòng chọn loại nguyên liệu đến',
'请输入条码编号': 'Vui lòng nhập mã vạch',
'请输入规格描述': 'Vui lòng nhập mô tả thông số kỹ thuật',
'请输入客户': 'Vui lòng nhập khách hàng',
'请输入储位': 'Vui lòng nhập kho',
'请输入批次号': 'Vui lòng nhập số lô',
'请选择超期状态': 'Vui lòng chọn trạng thái quá hạn',
'已超期': 'Đã hết hạn',
'未超期': 'Không quá hạn',
'请选择料架': 'Vui lòng chọn giá nguyên liệu',
'请选择条码状态': 'Vui lòng chọn trạng thái mã vạch',
'超期': 'Quá hạn',
'请输入特殊物料': 'Vui lòng nhập vật liệu đặc biệt',
'请选择仓库': 'Vui lòng chọn kho',
'锁定状态': 'Trạng thái khóa',
'条码状态': 'Trạng thái mã vạch',
'超期状态': 'Tình trạng quá hạn',
'条码号': 'Số mã vạch',
'货架编号': 'Số kệ',
'储位': 'Lưu trữ',
'生产日期(D/C)': 'Ngày sản xuất (D/C)',
'D/C': 'D/C',
'周期': 'Chu kỳ',
'客户编号': 'Số khách hàng',
'规格描述': 'Thông số kỹ thuật Description',
'特殊物料': 'Vật liệu đặc biệt',
'仓库编号': 'Số kho',
'仓库名称': 'Tên kho',
'备料单日志': 'Nhật ký dự trữ',
'来料类型': 'Loại vật liệu đến',
'单位名称': 'Tên đơn vị',
'批次': 'Hàng loạt',
'入库时间': 'Thời gian nhập kho',
'参考储位': 'Lưu trữ tham khảo',
'有效日期': 'Ngày hết hạn',
'按条码': 'bởi barcode',
'按物料编号汇总': 'Tóm tắt theo số vật liệu',
'按条码导出': 'Xuất theo mã vạch',
'按物料编号汇总导出': 'Tóm tắt xuất khẩu theo số vật liệu',
'炉后AOI记录': 'Ghi âm AOI sau lò',
'品质追溯': 'Chất lượng theo dõi',
'对账管理': 'Quản lý đối chiếu',
'物料库存': 'Vật liệu trong kho',
'数量计算': 'Tính toán số lượng',
'数量总和': 'Tổng số lượng',
'委外订单详情': 'Chi tiết đặt hàng ngoài ủy ban',
'是否签收': 'Có ký hay không',
'未签收':'Chưa ký',
'已出库': 'Đã xuất kho',
'成品出库数': 'Số lượng sản phẩm xuất kho',
'出库单号': 'Số thư viện',
'出库数量': 'Số lượng thư viện',
'出库时间': 'Thời gian xuất kho',
'请先勾选需要删除的数据！': 'Vui lòng kiểm tra dữ liệu cần xóa trước!',
'请填写必填项！': 'Vui lòng điền vào các mục bắt buộc!',
'列表为空，请添加数据！': 'Danh sách trống, vui lòng thêm dữ liệu!',
'对账管理详情': 'Chi tiết quản lý đối chiếu',
'请输入规格': 'Vui lòng nhập thông số kỹ thuật',
'请输入单位': 'Vui lòng nhập đơn vị',
'添加物料': 'Thêm vật liệu',
'编辑物料': 'Chỉnh sửa vật liệu',
'请输入物料规格': 'Vui lòng nhập thông số vật liệu',
'关闭订单': 'Đặt hàng',
'确认要关闭该订单吗？': 'Xác nhận bạn muốn đóng lệnh?',
'订单': 'Đặt hàng',
'物料资料': 'Thông tin vật liệu',
'物料尺寸': 'Kích thước vật liệu',
'归属客户编号': 'Số khách hàng thuộc sở hữu',
'归属客户': 'Khách hàng thuộc sở hữu',
'客户': 'Khách hàng',
'物料类型': 'Loại vật liệu',
'物料类别': 'Loại vật liệu',
'湿敏元件等级': 'Lớp yếu tố nhạy cảm ướt',
'工艺路线': 'Tuyến đường công nghệ',
'默认供应商': 'Nhà cung cấp mặc định',
'MRP类别': 'Loại MRP',
'包装数': 'Số gói',
'最大数量': 'Số lượng tối đa',
'最小数量': 'Số lượng tối thiểu',
'描述': 'Mô tả',
'物料详情': 'Chi tiết vật liệu',
'签收详情': 'Chi tiết đăng ký',
'工单编号': 'Số đơn đặt hàng',
'送货时间': 'Thời gian giao hàng',
'签收': 'Đăng ký',
'全部签收': 'Đăng ký tất cả',
'下单时间': 'Đặt hàng thời gian',
'全部签收时间': 'Tất cả thời gian đăng ký',
'结算时间': 'Thời gian thanh toán',
'关闭时间': 'Thời gian đóng cửa',
'关闭': 'Đóng cửa',
'添加其他费用明细': 'Thêm chi tiết chi phí khác',
'SPI': 'SPI',
'pcb条码号': 'Số mã vạch pcb',
'条码序号': 'Mã vạch Số sê-ri',
'条码数量': 'Số lượng mã vạch',
'DC号': 'Số DC',
'生产数量': 'Số lượng sản xuất',
'站位': 'Vị trí đứng',
'位号': 'Số bit',
'操作类型': 'Loại hoạt động',
'SMT板用料': 'Vật liệu cho bảng SMT',
'批号': 'Số lô',
'锡膏': 'Hàn dán',
'客户单号': 'Số khách hàng',
'有效时间': 'Thời gian hiệu lực',
'失效时间': 'Thời gian hết hạn',
'钢网': 'Lưới thép',
'钢网编号': 'Số lưới thép',
'最大使用次数': 'Số lần sử dụng tối đa',
'已使用次数': 'Số lần sử dụng',
'张力1': 'Sức căng 1',
'张力2': 'Căng thẳng 2',
'张力3': 'Căng thẳng 3',
'张力4': 'Căng thẳng 4',
'张力5': 'Căng thẳng 5',
'pcb料号': 'Số lượng PCB',
'pcb名称': 'Tên pcb',
'pcb规格': 'pcb đặc điểm kỹ thuật',
'客户订单号': 'Số đặt hàng của khách hàng',
'类别': 'Danh mục',
'DIP用料': 'Sử dụng DIP',
'新建用户': 'Người dùng mới',
'新建时间': 'Thời gian mới',
'先进先出码': 'Vào trước ra trước',
'板序号': 'Số bảng',
'插件过站': 'Plugin qua trạm',
'后焊过站': 'Trạm hàn sau',
'烧录过站': 'đốt trạm',
'测试过站': 'Đã kiểm tra trạm',
'包装过站': 'Đóng gói qua trạm',
'成品入库': 'Thành phẩm vào kho',
'成品出库': 'Xuất kho thành phẩm',
'维修管理': 'Quản lý bảo trì',
'检查结果': 'Kết quả kiểm tra',
'箱号': 'Số hộp',
'装箱数量': 'Số lượng đóng gói',
'建立时间': 'Thời gian xây dựng',
'累计入库数量': 'Tích lũy số lượng nhập kho',
'入库单据': 'Tài liệu nhập kho',
'出库单据': 'Tài liệu xuất kho',
'箱子容量': 'Công suất hộp',
'维修工具': 'Công cụ sửa chữa',
'维修次数': 'Số lần sửa chữa',
'是否返修': 'Sửa lại hay không',
'工序名称': 'Tên quy trình',
'缺陷数量': 'Số lượng khiếm khuyết',
'检验结果': 'Kết quả kiểm tra',
'维修结果': 'Kết quả sửa chữa',
'维修日期': 'Ngày sửa chữa',
'外壳序号': 'Số sê-ri vỏ',
'维修用户': 'Người dùng sửa chữa',
'请输入成品编号': 'Vui lòng nhập số sản phẩm',
'请输入条码号': 'Vui lòng nhập mã vạch',
'请输入批号': 'Vui lòng nhập số lô',
'请输入箱号': 'Vui lòng nhập số hộp',
'请输入钢网编号': 'Vui lòng nhập số lưới thép',
'请输入站位': 'Vui lòng nhập vị trí',
'请选择操作类型': 'Vui lòng chọn loại hoạt động',
'请输入入库单据': 'Vui lòng nhập tài liệu nhập kho',
'请输入出库单据': 'Vui lòng nhập tài liệu xuất kho',
'请选择工序': 'Vui lòng chọn quy trình',
'请输入位号': 'Vui lòng nhập số bit',
'合计(含税)': 'Tổng cộng (đã bao gồm thuế)',
'成品入库数': 'Số lượng thành phẩm trong kho',
'成品签收数': 'Số lượng đăng ký thành phẩm',
'入库单号': 'Số đơn nhập kho',
'入库数量': 'Số lượng vào kho',
'签收数量': 'Số lượng đăng ký',
'签收时间': 'Thời gian đăng ký',
'签收单号': 'Số đăng ký',
'不输入则系统分配默认单号': 'Không nhập thì hệ thống gán số đơn mặc định',
'操作成功': 'Hoạt động thành công',
'详情删除成功！': 'Xóa chi tiết thành công!',
'其他费用明细删除成功！': 'Các chi phí khác đã được xóa thành công!',
'详情保存成功！': 'Chi tiết bảo tồn thành công!',
'其他费用明细保存成功！': 'Các chi phí khác được bảo tồn thành công!',
'模块码': 'Mã mô-đun',
'请输入模块码': 'Vui lòng nhập mã mô-đun',
'请输入含税单价': 'Vui lòng nhập đơn giá đã bao gồm thuế',
'工作台': 'Bàn làm việc',
'邮箱': 'Hộp thư',
'微信': 'WeChat',
'验证码': 'Mã xác thực',
'绑定': 'Kết nối',
'解绑': 'Giải kết nối',
'请输入邮箱': 'Vui lòng nhập hộp thư',
'请输入微信': 'Vui lòng nhập WeChat',
'请输入验证码': 'Vui lòng nhập mã xác thực',
'秒后重试': 'Thử lại sau giây',
'发送验证码': 'Gửi mã xác thực',
'用户名': 'Tên người dùng',
'密码': 'Mật khẩu',
'手机号码': 'Số điện thoại di động',
'所属供应商': 'Nhà cung cấp',
'个人信息': 'Thông tin cá nhân',
'账号绑定': 'Kết nối tài khoản',
'已绑定': 'Đã kết nối',
'未绑定': 'Chưa kết nối',
'绑定邮箱，可及时接收订单动态': 'Kết nối hộp thư để nhận thông tin đơn hàng kịp thời',
'绑定微信，可及时接收订单动态': 'Kết nối WeChat để nhận thông tin đơn hàng kịp thời',
'请输入正确的手机号': 'Vui lòng nhập số điện thoại hợp lệ',
'修改成功': 'Sửa thành công',
'修改失败': 'Sửa thất bại',
'请查看电子邮箱获取验证码': 'Vui lòng kiểm tra hộp thư điện tử của bạn để lấy mã xác thực',
'请查看微信验证': 'Vui lòng kiểm tra xác thực WeChat',
'请输入电子邮件地址': 'Vui lòng nhập địa chỉ email',
'请输入有效的电子邮件地址': 'Vui lòng nhập địa chỉ email hợp lệ',
'请输入微信账号': 'Vui lòng nhập tài khoản WeChat',
'请选择送货单': 'Vui lòng chọn hóa đơn giao hàng',
'关闭标记': 'Tắt dấu',
'待办处理': 'Xử lý thay mặt',
'去下单': 'Đi đặt hàng',
'去签收': 'Đi nhận hàng',
'去处理': 'Đi xử lý',
'订单号': 'Số đơn hàng',
'事物类型': 'Loại đối tượng',
'代签收': 'Ký nhận thay',
'待齐套': 'Chờ đủ bộ',
'以排期': 'Đặt lịch',
'生产不良原因统计': 'Thống kê nguyên nhân sản xuất kém chất lượng',
'IPQC总不良数': 'Tổng số lỗi IPQC',
'工单完成进度': 'Tiến độ hoàn thành công việc',
'订单数量': 'Số lượng đơn hàng',
'日产量达成情况': 'Tình hình đạt sản lượng hàng ngày',
'目标数': 'Số mục tiêu',
'实际数': 'Số thực tế',
'产量完成环比分析': 'Phân tích so sánh tháng trước về sản lượng đã hoàn thành',
'当天': 'Ngày hôm đó',
'7天': '7 ngày',
'便携引导': 'Hướng dẫn di động',
'委外订单下达': 'Đặt hàng ngoài',
'加工订单录入,实现全流程溯源管理': 'Nhập đơn hàng chế biến để quản lý truy xuất toàn quá trình',
'物料齐套': 'Vật liệu đầy đủ',
'订单计划排期,工单物料齐套': 'Lên kế hoạch và đặt lịch đơn hàng, vật liệu công việc đầy đủ',
'通过条码查看生产过程信息': 'Xem thông tin quy trình sản xuất qua mã vạch',
'订单对账': 'Đối chiếu đơn hàng',
'订单对账及结束订单': 'Đối chiếu và kết thúc đơn hàng',
'预警信息': 'Thông tin cảnh báo sớm',
'订单结算统计': 'Thống kê thanh toán đơn hàng',
'物料欠料明细': 'Chi tiết thiếu hụt vật liệu',
'日记账号': 'Tài khoản nhật ký',
'导出明细': 'Xuất chi tiết',
'欠料': 'Thiếu vật liệu',
'全部': 'Tất cả',
'物料齐套处理': 'Xử lý đủ bộ vật liệu',
'齐套方式': 'Phương pháp đủ bộ',
'请选择齐套方式': 'Vui lòng chọn phương pháp đủ bộ',
'预计到料时间': 'Thời gian dự kiến đến vật liệu',
'联系人': 'Người liên hệ',
'联系方式': 'Thông tin liên hệ',
'请选择联系方式': 'Vui lòng chọn thông tin liên hệ',
'当前库存': 'Kho hiện tại',
'工单需求数': 'Số lượng yêu cầu trong đơn công việc',
'差异数': 'Số chênh lệch',
'首件': 'Sản phẩm đầu tiên',
'工单组名称': 'Tên nhóm đơn công việc',
'工单组编号': 'Số hiệu nhóm đơn công việc',
'状态': 'Trạng thái',
'是否已计算': 'Có tính toán chưa',
'已开始': 'Đã bắt đầu',
'发料': 'Phát vật liệu',
'已发料': 'Vật liệu đã phát',
'下线': 'Rời khỏi dòng',
'备料': 'Chuẩn bị vật liệu',
'激活': 'Kích hoạt',
'客户齐套': 'Khách hàng đủ bộ',
'齐套确认': 'Xác nhận đủ bộ',
'微信扫一扫':'WeChat lướt qua',
'未完成': 'chưa hoàn thành',
'完成': 'hoàn thành',
'未分类': 'Chưa phân loại',
'不良原因': 'Lý do không tốt',
'订单交期超期提醒': 'Nhắc nhở quá hạn giao hàng',
'工单总需求数': 'Số lượng yêu cầu tổng cộng của đơn công việc',
'理论库存': 'Kho lý thuyết',
'允损数': 'Số lượng cho phép mất mát',
'余数': 'Số dư',
'替代主料': 'Nguyên liệu chính thay thế',
'齐套': 'Đủ bộ',
'必须选择预计到料时间': 'Phải chọn thời gian dự kiến nhận hàng',
'必须选择齐套方式': 'Phải chọn phương pháp đủ bộ',
'必须填写联系人': 'Phải điền người liên hệ',
'必须填写联系方式': 'Phải điền thông tin liên lạc',
'是否是替代料': 'Có phải là vật liệu thay thế không',
'已齐套':'Đầy đủ',
'齐套状态':'Trạng thái đủ bộ',
'齐套单号': 'Số đơn đặt hàng',
'加载中...': 'Đang tải......',
'为了更方便您关注订单的实时状态，建议您进入个人中心完善资料，系统将更好的为您服务！': 'Để thuận tiện hơn cho bạn theo dõi trạng thái thời gian thực của đơn đặt hàng, đề nghị bạn vào trung tâm cá nhân hoàn thiện tài liệu, hệ thống sẽ phục vụ bạn tốt hơn!',
'请设置密码': 'Vui lòng đặt mật khẩu',
'请设置确认密码': 'Vui lòng đặt mật khẩu xác nhận',
'订单交付超期提醒': 'Nhắc nhở giao hàng quá hạn',
'易损物料最低库存预警': 'Cảnh báo tồn kho vật liệu dễ hỏng thấp nhất',
'订单超时未下单提醒': 'Nhắc nhở đơn hàng quá thời gian chưa đặt',
'订单未签收提醒': 'Nhắc nhở đơn hàng chưa ký nhận',
'订单已完成加工,未关闭提醒': 'Nhắc nhở đơn hàng đã hoàn thành chế biến, chưa đóng',
'微信公众号': 'WeChat công cộng',
'绑定微信公众号，可及时接收订单动态': 'Binding WeChat số công cộng, có thể nhận được động thái đơn đặt hàng kịp thời',
'微信小程序': 'Ứng dụng WeChat',
'绑定微信小程序，可随时查看订单动态': 'Ứng dụng WeChat ràng buộc để xem động thái đặt hàng bất cứ lúc nào',
'请输入原始密码': 'Vui lòng nhập mật khẩu hiện tại',
'请输入新密码': 'Vui lòng nhập mật khẩu mới',
'请再次输入新密码': 'Vui lòng nhập lại mật khẩu mới',
'密码修改': 'Chỉnh sửa mật khẩu',
'信息修改': 'Chỉnh sửa thông tin',
'旧密码': 'Mật khẩu cũ',
'新密码': 'Mật khẩu mới',
'确认密码': 'Xác nhận mật khẩu',
'修改密码': 'Thay đổi mật khẩu',
'使用账号登录': 'Đăng nhập bằng tài khoản',
'二维码获取失败': 'Nhận mã QR thất bại',
'二维码已过期': 'Mã QR đã hết hạn',
'重新获取二维码': 'Lấy lại mã QR',
'调用微信登录接口失败': 'Gọi giao diện đăng nhập WeChat không thành công',
'获取imes系统用户信息失败': 'Lỗi lấy thông tin người dùng hệ thống imes',
'获取imes系统账号信息失败': 'Nhận thông tin tài khoản imes không thành công',
'获取imes系统租户信息失败': 'Lỗi lấy thông tin đối tượng thuê hệ thống imes',
'您的微信还没有绑定系统账号，请用系统账号登陆后，在个人中心进行微信账号绑定': 'WeChat của bạn vẫn chưa có tài khoản hệ thống cố định, sau khi đăng nhập bằng tài khoản hệ thống, hãy tiến hành cố định tài khoản WeChat tại trung tâm cá nhân',
'发送短信配置': 'Gửi cấu hình SMS',
'发送短信手机号': 'Gửi số điện thoại SMS',
'请输入手机号': 'Vui lòng nhập số điện thoại',
'是否开启订单变更短信通知': 'Mở thông báo SMS thay đổi đơn đặt hàng',
'发送短信服务': 'Gửi tin nhắn SMS',
'工单排期': 'Thời gian đặt hàng công việc',
'工单生产': 'Sản xuất đơn hàng công việc',
'工单完成': 'Hoàn thành đơn đặt hàng',
'工单签收': 'Ký hợp đồng lao động',
'请输入完整的手机号码': 'Vui lòng nhập đầy đủ số điện thoại di động',
'验证码获取成功': 'Captcha thành công',
'绑定手机号': 'Số điện thoại liên kết',
'解绑手机号': 'Cởi trói số điện thoại',
'验证当前手机号': 'Kiểm tra số điện thoại hiện tại',
'修改手机号': 'Thay đổi số điện thoại',
'开启': 'Mở',
'工单完工': 'Hoàn thành đơn đặt hàng',
'手机号': 'Số điện thoại',
'获取验证码': 'Nhận CAPTCHA',
'验证': 'Kiểm tra',
'短信拒收时间': 'Thời gian từ chối SMS',
}


/*
  注意事项：
    1、中文的 ‘编号’ 翻译为越南语时会变成 ‘数量’ 的意思，所以要用 ‘编码’ 去翻译；
*/